import { EpsData } from 'src/devices/payment/dtos/eps-data';
import {
  isEnableCardEntryPerformed,
  waitForCardDetails,
} from 'src/devices/payment/get-card-details';
import {
  beginPaymentSession,
  enableCardEntry,
  inPaymentSession,
} from 'src/devices/payment/pinpad-operations';

/**
 * This function will request card details when entering the tendering view
 * It assumes that there's a pin pad already configured and the amount due is valid
 * (Not zero)
 * @param amountDue The amount due for tendering when entering the tendering view
 * @returns A promise that will resolve with card details
 */
export const checkForCardDetails = async (amountDue: number): Promise<EpsData | undefined> => {
  if (!inPaymentSession()) {
    await beginPaymentSession();
  }
  if (!isEnableCardEntryPerformed()) {
    await enableCardEntry();
  }
  return waitForCardDetails(amountDue, amountDue);
};
